import { EventHandlerBase } from "pytha2";
import { Vector3 } from "three";

/**
 * 移动快速生成的轴网
 */
export class EventHandlerMoveQuickAxisNet extends EventHandlerBase {

    // 移动的向量
    _vec = new Vector3();

    run(data = {}) {
        // console.log('移动快速生成的轴网 run');

        let pointdown = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList?.length - 1]?.point;
        // console.log('pointdown', pointdown);
        if (!pointdown) return false;

        const x = pointdown.x - this.node.graph.cache.data['basePoint'].x;
        const y = pointdown.y - this.node.graph.cache.data['basePoint'].y;
        const z = pointdown.z - this.node.graph.cache.data['basePoint'].z;
        this._vec.set(x, y, z)
        // console.log('this._vec', this._vec)

        // 进入这个处理器的basePoint一定在坐标原点
        let primitiveList = [];

        const cachePrimitives = this.node.graph.cache.data['tempPrimitives'];
        // const cachePrimitives = this.node.graph.cache.primitiveList;
        cachePrimitives?.forEach(pri => {
            pri.move(this._vec);
            // 这些图元需要重新放入tempPrimitiveDict,才能后续旋转
            pri.temporary = true;
            this.getPythaStorage().primitiveStore.tempPrimitiveDict[pri.uuid] = pri;
            pri.needRedraw = true;
            primitiveList.push(pri);
        })

        this.node.graph.cache.data['basePoint'] = pointdown.clone();
        this.node.graph.cache.primitiveList = [...primitiveList];
        this.getPythaStorage().selectStore.selectPrimitives = [...primitiveList];

        this.node.graph.cache.data['step'] = 2;
        return true;
    }

}